import { Flex, Switch, Text } from "@chakra-ui/react";
import useIsLandScapeMachine from "../../../hook/useIsLandScapeMachine";
import { useSearchParams } from "react-router-dom";

const VerticalGameSwitcher = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const showVertical = searchParams.get("show_vertical");

  const isMachineLandscape = useIsLandScapeMachine();

  return (
    isMachineLandscape && (
      <Flex>
        <Text>僅顯示直立遊戲：</Text>
        <Switch
          checked={showVertical === "1"}
          onChange={(e) => {
            setSearchParams({ show_vertical: e.target.checked ? "1" : "0" });
          }}
        />
      </Flex>
    )
  );
};

export default VerticalGameSwitcher;
